module.exports = __webpack_public_path__ + "img/icons_29.420c60d2.png";